import React from 'react';
import { Mail, Phone, User } from 'lucide-react';
const team = [{
  name: 'Matt Mihalcin',
  title: 'Managing Broker / Owner',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400&h=400'
}, {
  name: 'Janet Mihalcin',
  title: 'Co-Founder / Realtor',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400&h=400'
}, {
  name: 'Brandon Musante',
  title: 'Realtor',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=400&h=400'
}, {
  name: 'Josh Blackmer',
  title: 'Realtor',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400&h=400'
}];
export function Team() {
  return <section id="team" className="py-20 md:py-32 bg-white" data-id="element-155">
      <div className="container mx-auto px-4 md:px-6" data-id="element-156">
        <div className="text-center mb-16" data-id="element-157">
          <span className="text-brand-copper tracking-[0.2em] text-sm font-semibold uppercase mb-4 block" data-id="element-158">
            Our Team
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-6" data-id="element-159">
            The people behind Copper & Stone
          </h2>
          <p className="text-brand-taupe text-lg max-w-2xl mx-auto" data-id="element-160">
            A tight-knit, experienced local team dedicated to providing a
            personal, high-touch real estate experience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-16" data-id="element-161">
          {team.map(member => <div key={member.name} className="group text-center" data-id="element-162">
              <div className="relative w-48 h-48 md:w-56 md:h-56 mx-auto rounded-full overflow-hidden mb-6 shadow-md group-hover:shadow-xl transition-all duration-300 group-hover:-translate-y-2" data-id="element-163">
                <div className="w-full h-full flex items-center justify-center bg-brand-cream" role="img" aria-label={`${member.name} portrait placeholder`} data-id="element-164">
                  <User size={88} strokeWidth={1} className="text-brand-taupe/50" data-id="element-165" />
                </div>
                <div className="absolute inset-0 bg-brand-stone-900/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-4" data-id="element-166">
                  <a href="#" className="bg-white p-2 rounded-full text-brand-copper hover:bg-brand-copper hover:text-white transition-colors" data-id="element-167">
                    <Mail size={20} data-id="element-168" />
                  </a>
                  <a href="#" className="bg-white p-2 rounded-full text-brand-copper hover:bg-brand-copper hover:text-white transition-colors" data-id="element-169">
                    <Phone size={20} data-id="element-170" />
                  </a>
                </div>
              </div>
              <h3 className="text-2xl font-serif text-brand-charcoal mb-1" data-id="element-171">
                {member.name}
              </h3>
              <p className="text-brand-taupe text-sm uppercase tracking-wider" data-id="element-172">
                {member.title}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-173">
          <a href="#" className="text-brand-copper hover:text-brand-charcoal font-medium transition-colors border-b border-brand-copper pb-1" data-id="element-174">
            Meet the Full Team
          </a>
        </div>
      </div>
    </section>;
}